// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rf-2";
export var messageContent = "_rf-0";
export var messagesScroll = "_rf-1";
export var shimmer = "_rf-3";
export var shimmerW100 = "_rf-4";
export var shimmerW70 = "_rf-8";
export var shimmerW80 = "_rf-7";
export var shimmerW85 = "_rf-6";
export var shimmerW90 = "_rf-5";